<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 360" fill="#FFF" stroke="currentColor">
    <g
      transform="translate(0.000000,360.000000) scale(0.100000,-0.100000)"
      fill="#DDD"
      stroke="none"
    >
      <path
        d="M0 1800 l0 -1800 1800 0 1800 0 0 1800 0 1800 -1800 0 -1800 0 0
      -1800z m741 1400 c177 -33 346 -199 388 -380 16 -67 13 -227 -4 -295 -23 -88
      -73 -173 -141 -240 -240 -237 -640 -172 -792 130 -60 121 -75 299 -34 430 77
      253 324 403 583 355z m729 -364 l5 -48 20 22 c11 12 40 34 65 49 59 34 154 36
      216 4 187 -99 218 -434 58 -621 -57 -67 -122 -96 -219 -96 -59 -1 -89 4 -113
      17 l-34 18 4 -126 c3 -139 11 -155 69 -155 35 0 56 -24 39 -45 -18 -22 -362
      -22 -380 0 -18 22 2 41 52 48 22 3 45 11 49 19 12 17 11 809 0 827 -7 10 -20
      12 -49 7 -42 -6 -58 7 -46 38 7 19 201 96 234 93 22 -2 26 -7 30 -51z m1042
      17 c85 -48 144 -151 136 -241 l-3 -37 -227 -3 -228 -2 0 -23 c0 -48 31 -124
      67 -166 102 -119 258 -104 319 30 15 33 22 40 43 37 24 -3 26 -7 24 -45 -3
      -81 -72 -183 -155 -229 -45 -25 -64 -29 -128 -29 -129 0 -222 61 -279 185 -36
      79 -42 230 -12 328 44 147 171 236 323 228 51 -2 79 -10 120 -33z m466 -15 c2
      -27 6 -48 8 -48 3 0 24 16 46 34 44 38 114 66 162 66 43 -1 108 -32 134 -65
      43 -55 52 -113 52 -345 0 -241 4 -256 63 -262 27 -2 32 -7 32 -28 l0 -25 -171
      -3 c-143 -2 -173 0 -184 13 -18 21 4 45 41 45 56 0 61 23 57 264 -3 200 -4
      217 -24 243 -36 48 -109 40 -182 -22 l-33 -28 3 -213 c2 -149 7 -217 15 -225
      7 -7 29 -15 50 -18 32 -5 38 -10 38 -31 l0 -25 -180 0 -180 0 0 25 c0 21 5 26
      32 28 60 6 63 19 63 282 0 129 -4 241 -9 249 -6 10 -19 12 -44 7 -38 -7 -62
      10 -51 37 7 20 200 97 234 94 22 -2 25 -7 28 -49z m-2508 -1203 c16 -20 -3
      -45 -34 -45 -40 0 -60 -23 -53 -61 12 -58 201 -589 208 -581 3 4 37 95 74 202
      l67 195 -23 65 c-45 132 -81 180 -133 180 -8 0 -19 7 -26 15 -10 12 -10 18 0
      30 10 12 46 15 205 15 159 0 195 -3 205 -15 18 -21 -4 -45 -41 -45 -15 0 -35
      -7 -44 -17 -26 -26 -22 -42 135 -487 33 -93 56 -143 61 -135 13 25 188 536
      194 571 8 41 -8 58 -63 67 -31 5 -37 10 -37 31 l0 25 160 0 160 0 0 -25 c0
      -17 -6 -26 -20 -28 -38 -6 -62 -24 -82 -61 -11 -20 -89 -238 -173 -484 l-154
      -448 -30 3 c-30 3 -30 4 -133 292 -57 159 -104 291 -106 292 -2 2 -49 -129
      -106 -291 -102 -290 -105 -295 -131 -295 -17 0 -30 7 -35 18 -3 9 -74 206
      -157 437 -82 231 -159 441 -170 466 -18 44 -49 69 -82 69 -8 0 -19 7 -26 15
      -10 12 -10 18 0 30 18 22 372 22 390 0z m1614 5 c87 -13 143 -38 189 -84 48
      -48 68 -87 74 -150 11 -108 -41 -199 -143 -252 -33 -17 -66 -33 -74 -36 -15
      -5 15 -50 184 -277 77 -103 132 -146 203 -157 40 -6 44 -9 41 -33 l-3 -26
      -144 0 -144 0 -165 225 c-162 222 -164 225 -203 228 l-39 3 0 -174 c0 -206 4
      -217 86 -226 44 -5 49 -9 49 -31 l0 -25 -225 0 -225 0 0 25 c0 22 5 26 48 30
      87 10 82 -15 82 456 l0 416 -24 19 c-14 11 -39 19 -62 19 -41 0 -57 16 -45 45
      5 13 40 15 238 15 128 0 264 -5 302 -10z m1379 -107 c5 -125 0 -143 -38 -143
      -19 0 -24 7 -29 44 -14 91 -69 126 -196 126 l-81 0 3 -421 3 -421 24 -19 c13
      -10 38 -19 56 -19 41 0 63 -23 45 -45 -11 -13 -46 -15 -229 -13 l-216 3 0 25
      c0 22 5 26 48 30 86 10 82 -15 85 460 l3 420 -88 0 c-50 0 -99 -6 -113 -13
      -33 -17 -67 -69 -75 -118 -6 -36 -10 -40 -33 -37 -26 3 -27 6 -30 68 -2 36 -1
      93 3 128 l7 62 422 0 423 0 6 -117z"
      />
      <path
        d="M548 3106 c-57 -20 -85 -42 -123 -94 -50 -70 -76 -158 -82 -287 -9
      -184 32 -335 112 -418 57 -59 89 -72 180 -72 70 0 87 4 134 30 69 38 116 100
      144 189 18 60 22 93 21 211 -1 199 -31 302 -113 384 -64 64 -183 89 -273 57z"
      />
      <path
        d="M1545 2732 c-16 -11 -41 -31 -54 -45 -23 -25 -23 -28 -19 -199 4
      -193 9 -212 73 -242 77 -37 150 -7 194 79 23 44 26 61 26 155 -1 118 -22 184
      -75 235 -38 36 -103 44 -145 17z"
      />
      <path
        d="M2285 2790 c-31 -13 -74 -63 -84 -98 l-10 -32 135 0 c149 0 149 0
      117 67 -28 60 -99 88 -158 63z"
      />
      <path
        d="M1883 1553 c-23 -4 -23 -5 -23 -194 l0 -189 43 0 c97 0 189 47 224
      114 24 46 21 134 -6 182 -34 60 -81 88 -155 90 -33 1 -71 0 -83 -3z"
      />
    </g>
  </svg>
</template>

<style lang="scss" scoped>
svg {
  display: block;
  // path {
  //   fill: #A80030;
  //   stroke: none;
  // }
  height: auto;
}
</style>
